import { toast as toastify, ToastOptions } from 'react-toastify';
import { ToastFlavour } from '../../types';
import { ToastWithButton } from './Toast.components';

type Params = {
  flavour?: ToastFlavour;
  promise?: Promise<any>;
  cta?: {
    buttonText: string;
    onCta?: () => void;
    analyticsId?: string;
  };
  messages?: {
    pending: string;
    success: string;
    error: string;
  };
};

export function showToast(message: string, params: Params = {}): any {
  const { flavour, promise, cta, messages } = params;
  const { buttonText, analyticsId } = cta ?? {};

  const options: ToastOptions = {
    theme: 'light',
  };

  let id;

  const cmp = buttonText ? (
    <ToastWithButton
      message={message as string}
      flavour={flavour}
      buttonText={buttonText}
      onClick={cta?.onCta}
      analyticsId={analyticsId}
    />
  ) : (
    message
  );

  switch (flavour) {
    case 'error':
      id = toastify.error(cmp, options);
      break;

    case 'warning':
      id = toastify.warn(cmp, options);
      break;
    case 'promise':
      if (!promise || !messages) {
        return;
      }
      id = toastify.promise(promise, messages, options);
      break;
    case 'info':
      id = toastify.info(cmp, options);
      break;

    case 'custom':
      id = toastify(cmp, options);
      break;
    case 'success':
    default:
      id = toastify.success(cmp, options);
      break;
  }

  return id;
}

export function errorToast(message: string, params: Params): any {
  if (!message) return;
  return showToast(message, { ...params, flavour: 'error' });
}

export const toast = {
  show: showToast,
  error: errorToast,
};
